import { TActions } from '../../../AppModulesWrapper';

import { SAVE_DRAFT_FAIL, SAVE_DRAFT_START, SAVE_DRAFT_SUCCESS } from '../../actions/draft';
import { RESET_STATE } from '../../actions/resetState';
import { EOfferDraftStatus, IDraftState } from '../../types/reducers/draft';
import { defaultState } from './defaultState';

export function draft(state: IDraftState = defaultState, action: TActions): IDraftState {
  switch (action.type) {
    case SAVE_DRAFT_START: {
      return {
        ...state,
        status: EOfferDraftStatus.pending,
      };
    }

    case SAVE_DRAFT_SUCCESS: {
      return {
        ...state,
        status: EOfferDraftStatus.success,
      };
    }

    case SAVE_DRAFT_FAIL: {
      return {
        ...defaultState,
        status: EOfferDraftStatus.fail,
      };
    }

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
}
